import { restGet } from "apiCommandsExecutor/rest";

import {
    StatsCategoryRevenueDto,
    StatsIntervalDto,
    StatsItemRevenueDto,
    StatsSummaryDto,
    StatsTimeSeriesDto,
} from "./restModels";

/*
* Выборка статистики: меню и границы периода (epoch millis, как у списка заказов). Одна форма
* на все четыре ручки — они считают разное поверх одной и той же выборки заказов.
* */
export interface StatsPeriodFilter {
    menuId: number;
    from: number;
    to: number;
}

/*
* Период сравнения считает кабинет, а не бэк: «с начала недели» сравнивается со столькими же
* днями от начала прошлой недели, а не с окном такой же длины перед выбранным, — иначе среда
* сравнивалась бы с пятницей и субботой. Это знание о пресетах, то есть про интерфейс.
* */
export const getStatsSummary = (filter: StatsPeriodFilter, compare: StatsPeriodFilter | null) =>
    restGet<StatsSummaryDto>("/stats/summary", {
        menuId: filter.menuId,
        from: filter.from,
        to: filter.to,
        ...(compare === null ? {} : { compareFrom: compare.from, compareTo: compare.to }),
    });

export const getStatsTimeSeries = (filter: StatsPeriodFilter, interval: StatsIntervalDto) =>
    restGet<StatsTimeSeriesDto>("/stats/time-series", {
        menuId: filter.menuId,
        from: filter.from,
        to: filter.to,
        intervalAmount: interval.amount,
        intervalPeriod: interval.period,
    });

export const getStatsTopCategories = (filter: StatsPeriodFilter, limit: number) =>
    restGet<StatsCategoryRevenueDto[]>("/stats/top-categories", {
        menuId: filter.menuId,
        from: filter.from,
        to: filter.to,
        limit,
    });

export const getStatsTopItems = (filter: StatsPeriodFilter, limit: number) =>
    restGet<StatsItemRevenueDto[]>("/stats/top-items", {
        menuId: filter.menuId,
        from: filter.from,
        to: filter.to,
        limit,
    });
